import * as React from 'react';
import ECheckRowMobile from '../ECheckRowMobile';
import EmptyPayments from '../EmptyPayments';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import EcheckVoidModal from '../EcheckVoidModal';

interface IECheckTableMobileProps {
  payments: any[];
  selectedPayment: any;
  handlePaymentDetails: (payment: EcheckPaymentModel) => void;
}

interface IEcheckTableMobileState {
  paymentIdToVoid: number;
  showVoidModal: boolean;
}

class ECheckTableMobile extends React.Component<
  IECheckTableMobileProps,
  IEcheckTableMobileState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      paymentIdToVoid: null,
      showVoidModal: false
    };
  }

  private handlePaymentDetails = (e: any, payment: EcheckPaymentModel) => {
    e.preventDefault();
    this.props.handlePaymentDetails(payment);
  };

  private voidEcheck = (paymentId: number) => {
    this.setState({ paymentIdToVoid: paymentId, showVoidModal: true });
  };

  private handleCloseVoidModal = () => {
    this.setState({ showVoidModal: false });
  };

  private handleChangeCheckbox = (echeck: EcheckPaymentModel) => {
    if (!echeck.taker) {
      this.voidEcheck(echeck.databaseId);
    }
  };

  public render() {
    return (
      <div className="rp-echeck-table-mobile">
        {this.props.payments.length === 0 && <EmptyPayments />}
        {this.props.payments.map(payment => (
          <ECheckRowMobile
            key={payment.paymentNumber}
            payment={payment}
            onShowDetails={this.handlePaymentDetails}
            onChangeCheckbox={this.handleChangeCheckbox}
          />
        ))}
        {this.state.showVoidModal && this.state.paymentIdToVoid && (
          <EcheckVoidModal
            handleCloseModal={this.handleCloseVoidModal}
            paymentId={this.state.paymentIdToVoid}
          />
        )}
      </div>
    );
  }
}

export default ECheckTableMobile;
